module.exports = __webpack_public_path__ + "static/media/check-sign.03d00897.svg";